import { TableColumnMeta } from "ds/components/Table/types";

export enum READY_TO_MIGRATE_COLUMN_ID {
  NAME = "NAME",
  VERSION = "VERSION",
}

const MAX_CELL_WIDTH = 1200;

export const READY_TO_MIGRATE_TABLE_COLUMNS_CONFIG: Record<
  READY_TO_MIGRATE_COLUMN_ID,
  TableColumnMeta
> = {
  [READY_TO_MIGRATE_COLUMN_ID.NAME]: {
    id: READY_TO_MIGRATE_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 480,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [READY_TO_MIGRATE_COLUMN_ID.VERSION]: {
    id: READY_TO_MIGRATE_COLUMN_ID.VERSION,
    title: "OpenTofu version",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: 260,
    resizable: true,
    allowsSorting: false,
    canHide: false,
    configurable: true,
  },
};

export const READY_TO_MIGRATE_SORT_CONFIG: Partial<Record<READY_TO_MIGRATE_COLUMN_ID, string>> = {
  [READY_TO_MIGRATE_COLUMN_ID.NAME]: "name",
};
